import {
  getEnvironmentId,
  getRevisionId,
  isDevOrLocal,
  isLocal,
} from '../../utils/env';
import Honeybadger from 'honeybadger-js';

export function init() {
  Honeybadger.configure({
    apiKey: '8c0737ae',
    environment: getEnvironmentId(),
    revision: getRevisionId(),
    disabled: isLocal(),
  });
}

export function noticeError(e) {
  let errorToLog = e;
  if (typeof e === 'string') {
    errorToLog = new Error(e);
  }

  Honeybadger.notify(errorToLog);

  if (isDevOrLocal()) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

export function setUser(jigsawUser) {
  Honeybadger.setContext({
    user_id: jigsawUser ? jigsawUser.identifier || '' : '',
  });
}
